(function () {
  function qs(root, selector) {
    return root.querySelector(selector);
  }

  function qsa(root, selector) {
    return Array.prototype.slice.call(root.querySelectorAll(selector));
  }

  function initZoom(root) {
    qsa(root, '.fabric-swatch--zoom').forEach(function (swatch) {
      if (!swatch || swatch.getAttribute('data-zoom-init') === '1') return;
      swatch.setAttribute('data-zoom-init', '1');

      var media = qs(swatch, '.fabric-swatch__media');
      var img = qs(swatch, '.fabric-swatch__img');
      if (!media || !img) return;

      media.addEventListener('mouseenter', function () {
        swatch.classList.add('is-zooming');
      });

      media.addEventListener('mouseleave', function () {
        swatch.classList.remove('is-zooming');
        img.style.transformOrigin = 'center center';
      });

      media.addEventListener('mousemove', function (event) {
        var rect = media.getBoundingClientRect();
        var x = ((event.clientX - rect.left) / rect.width) * 100;
        var y = ((event.clientY - rect.top) / rect.height) * 100;
        img.style.transformOrigin = x + '% ' + y + '%';
      });
    });
  }

  function initOne(root) {
    if (!root || root.__fabricSwatchesZoomInit) return;
    root.__fabricSwatchesZoomInit = true;
    initZoom(root);
  }

  function boot(scope) {
    qsa(scope || document, '[data-fabric-swatches]').forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;

    if (event.target.matches && event.target.matches('[data-fabric-swatches]')) {
      event.target.__fabricSwatchesZoomInit = false;
      initOne(event.target);
      return;
    }

    boot(event.target);
  });
})();

(function () {
  function initGarmentGallery(root) {
    if (!root || root.dataset.galleryInitialized === 'true') return;

    const dialog = root.querySelector('.fabric-garment-modal');
    if (!dialog || typeof dialog.showModal !== 'function') return;

    const productsContainer = dialog.querySelector('.fabric-garment-modal__products');
    const closeButton = dialog.querySelector('.fabric-garment-modal__close');
    const title = dialog.querySelector('.fabric-garment-modal__header h2');

    if (!productsContainer || !closeButton || !title) return;

    root.dataset.galleryInitialized = 'true';

    root.addEventListener('click', function (event) {
      const button = event.target.closest('.fabric-swatch__view-garments');
      if (!button || !root.contains(button)) return;

      const swatch = button.closest('.fabric-swatch');
      if (!swatch) return;

      const data = swatch.querySelector('.fabric-swatch__gallery-data');
      if (!data) return;

      const name = swatch.querySelector('.fabric-swatch__label');

     
title.textContent = name ? name.textContent.trim() : '';

      productsContainer.replaceChildren(
        ...Array.from(data.children, child => child.cloneNode(true))
      );

      dialog.showModal();
      closeButton.focus();
    });

    closeButton.addEventListener('click', function () {
      dialog.close();
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) {
        dialog.close();
      }
    });
  }

  function bootGarmentGallery(scope) {
    const container = scope || document;

    if (container.matches && container.matches('[data-fabric-swatches]')) {
      initGarmentGallery(container);
    }

    container.querySelectorAll('[data-fabric-swatches]').forEach(initGarmentGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bootGarmentGallery(document);
    });
  } else {
    bootGarmentGallery(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    bootGarmentGallery(event.target);
  });
})();
